import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;
import Swal from 'sweetalert2';
import { CdkDragDrop, moveItemInArray, transferArrayItem,copyArrayItem} from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-faqlist',
  templateUrl: './faqlist.component.html',
  styleUrls: ['./faqlist.component.scss']
})
export class FaqlistComponent {

public dataListing:any=[];
  public AllData:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public Ids:any=''; 
  
  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");   
    this.getDetail(this.p);
    this.getQuestionDetail(this.p);
   }

  ngOnInit(): void {
  }

  getQuestionDetail(page:any){  
    this.loading = true;      
      var url='/faq?page='+page+'&search='+this.searchKey;      
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          this.dataListing= response.data.record;  
          this.totalCount = response.total; 
          this.loading=false;
        } else {
          this.dataListing=[]; 
          this.totalCount = response.total_record;
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
  }
  
  getDetail(page:any){  
    this.loading = true;      
      var url='/faq-content-listing?page='+page+'&search='+this.searchKey;      
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          this.AllData=response.data.record;
          this.loading=false;
        } else {
          this.AllData=[];
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
  }

    redirect(item:any,type:any){
      this.Ids =item._id;
      localStorage.setItem('gra_EditData',JSON.stringify(item));
        if(type ==1){
          this.router.navigate(['/edit-faq']);
        } else if(type ==3){
          this.router.navigate(['/edit-faqs']);
        } else {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
          }).then((result:any) => {
            let statusType: number = 0;
            if (result.isConfirmed) {
             this.delete();
            }
          });
        }
      }
    
      delete(){
        var url='/faq-delete?faq_id='+this.Ids;
        this.service.DeleteApi(url).subscribe(((response:any)=>{
          if(response.success ==1) {  
            this.loading=false;
            this.p=1;
            this.getDetail(this.p);
          } else {
            this.loading=false;
          }
        }), (error) => { this.loading =false; });
    
      } 

      drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.dataListing, event.previousIndex, event.currentIndex);
        this.OrderUpdate();
      }
    
      OrderUpdate(){
        this.loading= true;
        var kk:any=[];
        this.dataListing.filter((el:any)=>{
          kk.push(el._id);
        })
        var detail={
          "recordIds": kk
        }; 
        this.service.PostApis(detail,'/reorder-faq').subscribe(((response:any)=>{
          if(response.success ==1) {  
            this.loading=false;
            this.p=1;
            this.getQuestionDetail(this.p);
          } else {
            this.loading=false;
          }
        }), (error) => { this.loading =false; });
      }
}

